// // src/store/features/authSlice.js
// import { createSlice } from "@reduxjs/toolkit";
// import { loginUser, registerUser } from "store/thunks/authThunks";
// import { clearAuthData } from "utils/utils";

// const initialState = {
//   isAuthenticated: false,
//   user: null,
//   error: null,
//   loading: false,
//   data: null,
//   login: { count: 0 },
//   forgot: { count: 0 },
//   reg: { count: 0 },
//   alrdreg: { count: 0 },
//   varify: {},
// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     logout: (state) => {
//       state.isAuthenticated = false;
//       state.user = null;
//       clearAuthData();
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(loginUser.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(loginUser.fulfilled, (state, action) => {
//         state.loading = false;
//         state.isAuthenticated = true;
//         state.user = action.payload.user;
//       })
//       .addCase(loginUser.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       .addCase(registerUser.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(registerUser.fulfilled, (state, action) => {
//         state.loading = false;
//         state.isAuthenticated = true;
//         state.user = action.payload.user;
//       })
//       .addCase(registerUser.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { logout } = authSlice.actions;

// export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
// export const selectAuthError = (state) => state.auth.error;
// export const selectAuthLoading = (state) => state.auth.loading;

// export default authSlice.reducer;
// src/store/features/authSlice.js


import { createSlice } from "@reduxjs/toolkit";
import { loginUser, registerUser, socialLoginUser, forgotPassword, resetPassword } from "store/thunks/authThunks";
import { clearAuthData } from "utils/utils";

const initialState = {
  isAuthenticated: false,
  user: null,
  error: null,
  loading: false,
  data: null,
  login: { count: 0 },
  forgot: { count: 0 },
  reg: { count: 0 },
  alrdreg: { count: 0 },
  varify: {},
  user_status : null
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      clearAuthData();
    },
    clearAuth: (state) => {
      state.isAuthenticated = false;
      state.loading = false;
      state.data = null;
      state.error = null;
      state.user = null;
      state.user_status = null

    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.user_status = action.payload.user_status;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user_status = action.payload.user_status;
        state.user = action.payload.user;


        
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(socialLoginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(socialLoginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.user_status = action.payload.user_status;

      })
      .addCase(socialLoginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      

      .addCase(forgotPassword.pending, (state) => {
         state.loading = true;
        state.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
        state.count += 1;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(resetPassword.pending, (state) => {
         state.loading = true;
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
        state.count += 1;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout  ,clearAuth} = authSlice.actions;

export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthError = (state) => state.auth.error;
export const selectAuthLoading = (state) => state.auth.loading;

export default authSlice.reducer;

